import { render, staticRenderFns } from "./Lost.vue?vue&type=template&id=552f8b80&"
import script from "./Lost.vue?vue&type=script&lang=js&"
export * from "./Lost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports